import type { SortDirection } from '~publish/gql/graphql'

import { BulkActionsMenu } from './BulkActionsMenu'
import { FilterAndSortMenu } from './FilterAndSortMenu'
import { FilterStatusMenu } from './FilterStatusMenu'
import { DEFAULT_STATUS, type FilterStatus, type DateRange } from './types'

export type CommentsFiltersProps = {
  status?: FilterStatus
  sortDirection?: SortDirection
  publishedAt?: DateRange
  setStatus: (status: FilterStatus) => void
  setSortDirection: (direction: SortDirection) => void
  setPublishedAt: (publishedAt: DateRange) => void
  clearFilters: () => void
  channelId: string
}

export const CommentsFilters = ({
  status = DEFAULT_STATUS,
  sortDirection = 'desc',
  publishedAt = 'alltime',
  setStatus,
  setSortDirection,
  setPublishedAt,
  clearFilters,
  channelId,
}: CommentsFiltersProps): JSX.Element => {
  return (
    <>
      <FilterStatusMenu value={status} onChange={setStatus} />
      <FilterAndSortMenu
        sortDirection={sortDirection ?? 'desc'}
        onSortDirectionChange={setSortDirection}
        publishedAt={publishedAt}
        onPublishedAtChange={setPublishedAt}
        onResetFilters={(): void => clearFilters()}
      />
      <BulkActionsMenu channelId={channelId} />
    </>
  )
}
